// extracted by mini-css-extract-plugin
export var actionButton = "_xj-2";
export var card = "_xj-0";
export var disambiguationList = "_xj-3";
export var errorCard = "_xj-4";
export var row = "_xj-1";